import { Delete } from '../helpers';

const DeleteTemplateCategory = ({ categoryUuid }: { categoryUuid: string }) => {
  return Delete({ path: `/v3/admin/templates-category-filters/${categoryUuid}` });
};

export default DeleteTemplateCategory;
